module.exports = __webpack_public_path__ + "static/media/4.2in1 Pulvarizer.e8d327d1.jpg";